import { Box, BoxProps } from 'grommet';
import { Right } from 'lib/api';
import { rightStatusTone } from 'src/utils/styling';
import { StatusPill } from '../StatusPill';

export type RightStatusDisplayProps = BoxProps & {
  right: Partial<Right>;
};

export const RightStatusDisplay = ({ right, ...props }: RightStatusDisplayProps) => (
  <Box {...props}>{right.status && <StatusPill label={right.status} tone={rightStatusTone(right.status)} />}</Box>
);
